import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Pie } from "@ant-design/plots";
class PieChart extends Component {
  render() {
    const data = this.props.data;
    const config = {
      style: {
        marginTop: "25px",
      },
      appendPadding: 50,
      data,
      angleField: "value",
      colorField: "type",
      radius: 1,
      innerRadius: 0.6,
      label: {
        offset: "-50%",
        style: {
          textAlign: "center",
          fontSize: 14,
        },
      },
      statistic: {
        title: false,
        content: {
          style: {
            whiteSpace: "pre-wrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          },
        },
      },
    };
    return (
      <div>
        <Pie className="PieCard-Chart" {...config} />
      </div>
    );
  }
}

export default withRouter(PieChart);
